/* eslint-disable camelcase */
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export const ADDON_STATUS_PENDING = 10
export const ADDON_STATUS_ACTIVE = 20
export const ADDON_STATUS_CANCEL_SCHEDULED = 25
export const ADDON_STATUS_CANCELED = 30

export const ADDON_STATUS_TONE = {
  [ADDON_STATUS_PENDING]: 'info',
  [ADDON_STATUS_ACTIVE]: 'success',
  [ADDON_STATUS_CANCEL_SCHEDULED]: 'error',
  [ADDON_STATUS_CANCELED]: 'neutral',
}

const CREDIT_CARD_METHOD_ID = 10

export const formatAddonDate = iso => {
  if (!iso) return ''
  try {
    return format(new Date(iso), 'dd/MM/yyyy', { locale: ptBR })
  } catch (e) {
    return ''
  }
}

// O plano é pré-pago: a fatura do ciclo sai no começo dele. Por isso cobrança e
// acesso deixaram de andar juntos — contratar/aumentar cobra o pró-rata na hora,
// reduzir/cancelar só sai da próxima fatura e o acesso segue até o fim do ciclo
// já pago. Um add-on pode então estar EM USO numa quantidade e SENDO COBRADO em
// outra, e cada tela precisa saber qual das duas está exibindo:
//   quantity          -> quantidade de acesso (capacidade, uso, vagas)
//   billed_quantity   -> quantidade que a próxima fatura vai cobrar (dinheiro)
//   scheduled_quantity-> != null => existe redução agendada; é o valor futuro
//   quantity_change_at-> quando a redução entra em vigor (fim do ciclo pago)

export const accessQuantity = contract => Number(contract?.quantity ?? 0)

// billed_quantity já vem pronto da API (scheduled_quantity ?? quantity);
// o fallback existe só para respostas antigas em cache.
export const billedQuantity = contract =>
  Number(
    contract?.billed_quantity ??
      contract?.scheduled_quantity ??
      contract?.quantity ??
      0
  )

export const scheduledQuantity = contract =>
  contract?.scheduled_quantity != null
    ? Number(contract.scheduled_quantity)
    : null

export const hasScheduledReduction = contract =>
  contract != null && contract.scheduled_quantity != null

// "3 em uso · passa a 2 em 30/09/2026"
export const scheduledReductionLabel = contract => {
  if (!hasScheduledReduction(contract)) return ''

  const date = formatAddonDate(contract.quantity_change_at)
  const base = `${accessQuantity(contract)} em uso · passa a ${
    contract.scheduled_quantity
  }`

  return date ? `${base} em ${date}` : base
}

// Quanto a próxima fatura fica MENOR que o total exibido hoje. O total da
// assinatura soma os add-ons pela quantidade de ACESSO e ainda inclui os de
// cancelamento agendado (o ciclo vigente segue pago), mas no gateway os dois
// casos já foram reduzidos: uma redução agendada cobra billed_quantity e um
// add-on com cancelamento agendado não é mais cobrado.
// price_snapshot está em centavos; o retorno também.
export const nextInvoiceReductionCents = (contracts = []) =>
  (contracts || []).reduce((acc, contract) => {
    const price = Number(contract?.price_snapshot || 0)

    if (contract?.status === ADDON_STATUS_CANCEL_SCHEDULED) {
      return acc + price * accessQuantity(contract)
    }

    if (hasScheduledReduction(contract)) {
      return acc + price * (accessQuantity(contract) - billedQuantity(contract))
    }

    return acc
  }, 0)

export const isBoletoMethod = paymentMethodId =>
  paymentMethodId != null && `${paymentMethodId}` !== `${CREDIT_CARD_METHOD_ID}`

// Aviso obrigatório para quem paga em boleto: o acesso é liberado na hora, mas
// contratar ou aumentar gera uma cobrança avulsa do proporcional.
export const BOLETO_PRORATA_NOTICE =
  'Foi gerada uma cobrança do valor proporcional aos dias restantes deste ciclo, com vencimento em 5 dias.'

export const BOLETO_PRORATA_HINT =
  'Você paga em boleto: contratar um serviço ou aumentar a quantidade libera o acesso na hora e gera uma cobrança do valor proporcional aos dias restantes deste ciclo.'

export const BOLETO_PRORATA_HINT_ADMIN =
  'O cliente paga em boleto: contratar um serviço ou aumentar a quantidade libera o acesso na hora e gera uma cobrança do valor proporcional aos dias restantes deste ciclo.'
